import React, { useState, useEffect, useContext, useCallback } from "react";
import { useParams } from "react-router-dom";
import { Collapse, Row } from "reactstrap";
import { Tabs, Tab } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ClientBody.css";
import { Popover as AntdPopover, Button } from "antd";
import { faCaretDown, faChevronCircleDown, faChevronCircleRight, faEllipsisV, faLock, faPen, faSearchDollar, faTimes, faStar as filledstar } from "@fortawesome/free-solid-svg-icons";
import rightexpand from "../../assets/images/svg/right.svg"
import leftexpand from "../../assets/images/svg/left.svg"
import rightexpandactive from "../../assets/images/svg/rightactive.svg"
import leftexpandactive from "../../assets/images/svg/leftactive.svg"
import { SECTION_CONFIG } from "../Deal/DealListColDef"; 
import GetRecordById from "../../common/util/getRecordById";
import { typeOf } from "mathjs";
import Tab_Workdrive from "../../tabs/Workdrive/tab_workdrive";
import leftexpandactivegray from "../../assets/images/svg/left-active-grayunderline.svg";
import blurLeftPng from '../../assets/images/left-blur-1.png'
import ClientProgress from "../../tabs/ClientProgress/ClientProgress";
import RolesPopupData from "../Roles/RolesPopupData";
import AwsServerService from "../../common/util/AwsServerService";
import { GrEdit } from "react-icons/gr";
import { RiDeleteBinLine } from "react-icons/ri";
import AppContext from "../../Context/AppContext";
import moment from "moment";
import Email from "../EmailSection/email";
import { useSelector } from "react-redux";

const ClientBody = (props) => {
    const ModuleContacts = useSelector((state) => state.AppReduxContext.moduleContacts);
    const history = props.history;
    const params = useParams();
    const location = props.location;
    location.state = params;
    useEffect(() => {
        if (props.getParams) {
            props.getParams(params);
        }
    }, [location])
    const [data, setData] = useState({})
    const [settingToggle, setSettingToggle] = useState(false);
    const [contactToggle, setContactToggle] = useState(false);
    const [documentToggle, setDocumentToggle] = useState(false);
    const [serviceToggle, setServiceToggle] = useState(false);
    const [accountingToggle, setAccountingToggle] = useState(true);
    const [aboutToggle, setAboutToggle] = useState(true);
    const [rightState, setRightState] = useState(false);
    const [leftState, setLeftState] = useState(false);
    const [openSections, setOpenSections] = useState({});
    const [key, setKey] = useState("progress");
    const [clientkey, setClientKey] = useState([]);
    const [clientvalue, setClientValue] = useState([]);
    const [textVisib, setTextVisible] = useState('');
    const [SearchedItem, setSearchedItem] = useState("");
    const [textKey, setTextKey] = useState('');
    const [dealTopBoxCollapse, setDealTopBoxCollapse] = useState(true)
    const [tabArr, setTabArr] = useState(["Progress", "Emails", "Notes", "Tasks", "Activities", "Accounting"]);
    const [remaingTab, setRemaingTab] = useState(["Workdrive"]);

    //For Role Module by Makarand
    const AppData = useContext(AppContext);
    const { dispatch, state } = AppData || {};
    const [allRoles, setAllRoles] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedContactRole, setselectedContactRole] = useState([]);
    const defaulRoleState = { open: false, module: "", data: null, type: "create" };
    const [openRoleModal, setOpenRoleMadal] = useState({ open: false, module: "", data: null, type: "create" });
    const [projectRoleObject, setprojectRoleObject] = useState({
        "RoleId": "",
        "UserId": "",
        "UserType": "",
    })
    

    const onCloseRoleModal = (data) => {
        setOpenRoleMadal(defaulRoleState);
    }

    const changeRightExpand = () => {
        setRightState(!rightState);
    }

    const changeLeftExpand = () => {
        setLeftState(!leftState);
    }
    
    const toggleSection = (title) => {
        setOpenSections(prev => ({
            ...prev,
            [title]: !prev[title]
        }));
        };

    const formatLabel = (key) => {
        return key
            .replaceAll("sandeepext", "")
            .replaceAll("_", " ")
            .replaceAll("__", " ");
        };

    const handleDeleteUserRole = ({ ROWID }) => {
        if (ROWID) {
            AwsServerService.CrudServiceHandler({ method: "DELETE", data: {ROWID: ROWID}, route: "USERROLES" }).then(res => {
                fetRoles({ Client_Id: data.id });
                // dispatch(Socket({ trigger: "Refresh_Module", data: { module: "DEAL_DASH_USERROLE", id: data?.id } }))
            }).catch(e => {
                console.log(e);
            })
        }
    }
    const getRoles = () => {
        // props.setLoader(true);
        AwsServerService.CrudServiceHandler({ method: "GET", data: "", route: "ROLES" }).then(res => {
            setAllRoles(res.data);
           // props.setLoader(false);
        }).catch(err => {
            console.log(err);
            //props.setLoader(false);
        })
    }
    const fetRoles = ({ Client_Id }) => {
        if (Client_Id) {
            //props.setLoader(true);
            AwsServerService.CrudServiceHandler({ method: "GETWHERE", data: { ProjectId: Client_Id }, route: "USERROLES" }).then(res => {
                setselectedContactRole(res.data);
                // props.setLoader(false);
            }).catch(err => {
                //props.setLoader(false);
                console.log(err);
            })
        }
    }
    const getUserThumbnailUrl = (zuid) => {
        const loginProfileUrl =
            "https://contacts.zoho.com/file?ID=" + zuid + "&fs=thumb";
        return loginProfileUrl;
    };

    const renderFieldData = useCallback(({ UserId, UserType, RoleId, flag }) => {
        // Handle Roles
        const contact = ModuleContacts;
        if (flag === "Role") {
            const role = allRoles.find((r) => r.ROWID === RoleId);
            return role?.RoleName || "N/A"; // Fallback for undefined role
        }

        // Handle Accounts
        if (UserType === "Accounts") {
            const account = state?.AllAccounts?.find((a) => a.id === UserId);
            return (
                <div className="User-Role-Wrapper">
                    <img
                        alt=""
                        style={{ width: "33px", marginRight: "4px" }}
                        className="User-Image"
                        src={getUserThumbnailUrl(UserId)}
                    />
                    {account?.Account_Name || "N/A"}
                </div>
            );
        }

        // Handle Zoho Users
        if (UserType === "Zoho Users") {
            const user = state?.AllAppUsers?.find((a) => a.zuid === UserId);
            return (
                <div className="User-Role-Wrapper">
                    <img
                        alt=""
                        style={{ width: "33px", marginRight: "4px" }}
                        className="User-Image"
                        src={getUserThumbnailUrl(UserId)}
                    />
                    {user?.full_name || "N/A"}
                </div>
            );
        }

        // Handle Dynamic Modules
        // const moduleOptions = options[UserType]; // Ensure options are grouped by UserType
        const moduleOptions = UserType == "Deal" ? Object.values(contact).flat() : contact[UserType]

        if (moduleOptions) {
            const moduleData = moduleOptions.find((o) => o.id === UserId);
            return (
                <div className="User-Role-Wrapper">
                    <img
                        alt=""
                        style={{ width: "33px", marginRight: "4px" }}
                        className="User-Image"
                        src={getUserThumbnailUrl(UserId)}
                    />
                    {moduleData?.Full_Name || moduleData?.full_name || moduleData?.label || moduleData?.name || "N/A"}
                </div>
            );
        }

        // Fallback for unexpected cases
        return "Data not available";
    }, [state.AllAccounts, state.AllAppUsers, allRoles, ModuleContacts]);
    //End of code module By makarand
    useEffect(e => {
        getRoles()
        let arr = [];
        arr.push(params.id)
        props.setSelectedIds(arr)
    }, [])

    const getStyleExpandIco = () => {
        if (rightState) {
            if (leftState) {
                return { paddingLeft: '12px', paddingRight: '12px' }
            } else {
                return { paddingRight: '12px' }
            }

        }
        else if (leftState) {
            if (rightState) {
                return { paddingLeft: '12px', paddingRight: '12px' }
            } else {
                return { paddingLeft: '12px' }
            }
        }
        else if (leftState && rightState) {
            return { paddingLeft: '12px', paddingRight: '12px' }
        }
        else {
            return {}
        }

    }



    useEffect(() => {
        if (params) {
            GetRecordById(params.module, params.id)
                .then((data) => {
                    if (data) {
                        data = { ...data[0] };
                        delete data.Subform_2;
                        // delete data.Owner;
                        // delete data.Modified_By;
                        // delete data.Created_By;
                        // delete data.Tag;
                        setData(data);
                        fetRoles({ Client_Id: data.id })
                    } else {
                        props?.setDeleteDealFlag('')
                        history.push("/clientlist/Accounts/listview")
                    }
                })
                .catch(err => {
                    console.log(err);
                })
        }
    }, [params])

    useEffect(() => {
        if (data) {
            let keys = Object.keys(data)
            keys = keys.filter(key => key && (!key.includes('$')));
            setClientKey(keys);
            let arrValue = []
            keys.forEach((key) => {
                arrValue.push(data[key]);
            })
            setClientValue(arrValue)


        }
    }, [data])

    const tilesColumn = ['Deal_Name', 'Account_Name', 'Accounts', "Project_Status"];
    const getViewTabs = (tab) => {

        switch (tab) {
            case "Progress":
                return <Tab className="client_body_deals" eventKey="progress" title="Progress">
                    <ClientProgress
                        selectedIds={props.selectedIds}
                        setSelectedIds={props.setSelectedIds}
                        setCheckType={props.setCheckType}
                        checkType={props.checkType}  
                        deleteDealFlag={props.deleteDealFlag}
                        setDeleteDealFlag={props.setDeleteDealFlag} 
                        data={data}
                        getParams={props.getParams}
                        params={{ module: 'Deals', action: 'listview' }}
                        history={history}
                        location={location}

                    />

                </Tab>
            case "Emails":
                return <Tab eventKey="emails" title="Emails">
                    <Email 
                    // {...props}
                    clickedFromBody={false}
                    location={props.location}
                    allTask={props.allTask}
                    allUsers={props.allUsers}
                    cacheDeals={props.cacheDeals} 
                    getParams={props.getParams}
                    dealObj={"newObj"}
                    fromAccounts={true}
                    clientData={data}
                    />
                </Tab>
            case "Notes":
                return <Tab eventKey="notes" title="Notes">
                    Notes
                </Tab>
            // case "Tasks":
            //     return <Tab className={"client-body-task"} eventKey="tasks" title="Tasks">
            //         <TaskListWithDeal data={data} />

            //     </Tab>
            case "Activities":
                return <Tab eventKey="activities" title="Activities">
                    Activities
                </Tab>
            case "Accounting":
                return <Tab eventKey="accounting" title="Accounting">
                    Accounting
                </Tab>
            case "Workdrive":
                return <Tab eventKey="workdrive" title="Workdrive">
                    <Tab_Workdrive data={data} />
                </Tab>
            default:
                return <></>
        }
    }

    const getTilesStatusDropdown = (data, key, dataType) => {
        if (dataType.toLowerCase() == 'string') {
            if (tilesColumn.includes(key)) {
                if (key == 'Project_Status') {
                    // return  <StatusDropdown toggelButton={
                    //     <span style={projectData.custom_status_color ? { backgroundColor: projectData.custom_status_color } : { backgroundColor: 'lightgray' }} className="project_status_custom">{projectData.custom_status_name ? projectData.custom_status_name : "N/A"} <FontAwesomeIcon style={{ marginLeft: '30px' }} icon={faCaretDown} /></span>

                    // } items={getDealStatus()} onSelect={(value) => {
                    //     updateProject("custom_status", value.id, value.name)
                    //     // updateTask(data, "custom_status", value.id)
                    // }} />
                } else {
                    // return <StatusDropdown toggelButton={
                    //     <sapn style={{ backgroundColor: '#5b6c97' }} className="project_status_custom">{data[key] ? data[key] : "N/A"}</sapn>

                    // } items={[]} onSelect={(value) => {
                    //     // updateProject("custom_status", value.id, value.name)
                    //     // updateTask(data, "custom_status", value.id)
                    // }} />
                }

            } else {
                const value = key=="Last_Activity_Time" ? moment(data[key] || new Date()).format("MM-DD-YYYY hh:mm A") : data[key];
                if (Array.isArray(value)) {
                    return value.map((item, index) => (
                        <div key={index} style={{ marginBottom: '4px' }}>
                            {item.Item && <p><strong>Item:</strong> {item.Item}</p>}
                            {item.Billing_Stage_Task && <p><strong>Task:</strong> {item.Billing_Stage_Task}</p>}
                            {item.Billing_Stage_Task_Status && <p><strong>Status:</strong> {item.Billing_Stage_Task_Status}</p>}
                            {item.Cost && <p><strong>Cost:</strong> {item.Cost}</p>}
                            {item.Parent_Id?.name && <p><strong>Parent:</strong> {item.Parent_Id.name}</p>}
                        </div>
                    ));
                } else {
                    return value;
                }
                // return data[key]
            }
        }
        if (dataType == 'Object') {
            if (tilesColumn.includes(key)) {
                // return <StatusDropdown toggelButton={
                //     <sapn style={getClientColor(data.Account_Name ? data.Account_Name.id : '')} className="project_status_custom">{data[key] ? data[key].name : "N/A"} </sapn>

                // } items={[]} onSelect={(value) => {
                //     // updateProject("custom_status", value.id, value.name)
                //     // updateTask(data, "custom_status", value.id)
                // }} />
            } else {
                return data[key].name
            }
        }



    }


    const doSearch = (name) => {
        const fields = { ...data };
        let arr = Object.keys(fields)
        if (name !== "") {
            let obj = {}
            Object.keys(fields).forEach((key) => {
                let originalKey = key.replaceAll('sandeepext', '');
                originalKey = originalKey.replaceAll('_', ' ');
                originalKey = originalKey.replaceAll('__', ' ');
                if (originalKey.toLowerCase().includes(name.toLowerCase())) {
                    // arr.push(key)
                    obj[key] = fields[key];
                }
            })
            setSearchedItem(obj)
        }
        setClientKey(arr);
        setSearchedItem(name)
    };
    const SHORTHEAD = (key) => {
        if (key == "Parent Account Uppercase") {
            return "Parent Account"
        }else if (key == "Last Activity Time") {
            return "Last Activity"
        }else if(key == "Client Nick Name"){
            return "Nick Name"
        }else if(key == "Tier Number"){
            return "Number of Payment Tiers"
        }
        return key
    }

    const CUSTOM_RENDERERS = {
        Service_Adders: (value) => {
            const names = value.map(v => v.Service_Name).join(", ");
            const total = value.reduce((s,v)=> s + Number(v.Service_Cost || 0),0);
            return <><p key={key} style={{display: "flex",justifyContent: "space-between"}} className="abt-deal-field">
            <strong style={{color: "#2c2c2c"}}>Services :</strong> <span>{names}</span> </p> 
            <p style={{display: "flex",justifyContent: "space-between"}} className="abt-deal-field">
            <strong style={{color: "#2c2c2c"}}>Total Service Cost:</strong> <span>${total}</span></p>
            </>;
        }
        };

    return (

        <div className="pad-col ">
            <Row className="row-mar-0">
                <div className={leftState ? "display-none" : "widthper-21"}>

                    <div className="col-3-border outer-border-3">
                        <div className="collapse-body-tiles" onClick={() => setDealTopBoxCollapse(!dealTopBoxCollapse)}>
                            {dealTopBoxCollapse ? (
                                <FontAwesomeIcon
                                    className="mar-right-5"
                                    icon={faChevronCircleDown}
                                />
                            ) : (
                                <FontAwesomeIcon
                                    className="mar-right-5"
                                    icon={faChevronCircleRight}
                                />
                            )}
                            Account Overview
                        </div>
                        <div className="collapse-body-tiles-border"></div>
     <Collapse className="contact-roles" isOpen={dealTopBoxCollapse}>
    <div className="deal-details-topbox">
 
        <div className="stacked-field">
            <div className="field-label">Account ID:</div>
            <div className="field-value">{data.id}</div>
        </div>
 
        <div className="stacked-field">
            <div className="field-label">Created By:</div>
            <div className="field-value">{data?.Created_By?.name}</div>
        </div>
 
        <div className="stacked-field">
            <div className="field-label">Created Date:</div>
            <div className="field-value">
                {moment(data?.Created_Time || new Date()).format("MM-DD-YYYY")}
            </div>
        </div>
 
        <div className="stacked-field">
            <div className="field-label">Account Status:</div>
                                          <span
                                    className={`status-badge ${data?.Status ? "active" : "inactive"}`}
                                >
                                    {data?.Status ? "Active" : "Inactive"}
                                </span>
        </div>
 
        <div className="stacked-field">
            <div className="field-label">Phone Number:</div>
            <div className="field-value">{data.Phone}</div>
        </div>
 
    </div>
</Collapse>
                        <div className="collapse-body-tiles" onClick={() => {
                            setAboutToggle(!aboutToggle);
                        }}>
                            {aboutToggle ? (
                                <FontAwesomeIcon
                                    className="mar-right-5"
                                    icon={faChevronCircleDown}
                                />
                            ) : (
                                <FontAwesomeIcon
                                    className="mar-right-5"
                                    icon={faChevronCircleRight}
                                />
                            )}
                            Account Information
                        </div>
                        <div className="collapse-body-tiles-border"></div>

                        <div className=" ">
                            <div className="deal-details-bottumbox">
                                <div
                                    className="head-list-style about-deals-collapse font-14"
                                >
                                    <Collapse isOpen={aboutToggle}>
                                        <div className="position-relative about-deal-search">
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                className="pad-fix search-filter-deals"
                                                value={SearchedItem}
                                                onChange={(e) => doSearch(e.target.value)}
                                            />
                                            {SearchedItem ? ( <FontAwesomeIcon
                                                    onClick={() => setSearchedItem("")}
                                                    className="search-ico2"
                                                    icon={faTimes}
                                                /> ) : ( <FontAwesomeIcon
                                                    className="search-ico2"
                                                    icon={faSearchDollar}
                                                /> )}
                                        </div>
                                        <div style={dealTopBoxCollapse ? 
                                            { height: 'calc(97vh - 535px)' } : 
                                            { height: 'calc(97vh - 245px)' }} 
                                            className="about-this-account-content"
                                            >
                                        {SECTION_CONFIG.map((section) => {
                                            const filteredFields = section.fields.filter((key) => {
                                                if (!data[key]) return false;

                                                if (!SearchedItem) return true;

                                                const label = key
                                                .replaceAll("sandeepext", "")
                                                .replaceAll("_", " ")
                                                .toLowerCase();

                                                const value = String(data[key] || "").toLowerCase();

                                                return (
                                                label.includes(SearchedItem.toLowerCase()) ||
                                                value.includes(SearchedItem.toLowerCase())
                                                );
                                            });

                                            if (filteredFields.length === 0) return null;

                                            return (
                                                <div key={section.title} className="deal-section">
                                                <div
                                                    className="deal-section-header"
                                                    onClick={() => toggleSection(section.title)}
                                                >
                                                    <span style={{color:openSections[section.title]?"#5b6ca4":"#bfbfbf"}}>{section.title}</span>
                                                    <span className="collapse-icon">
                                                    <FontAwesomeIcon icon={openSections[section.title]?faChevronCircleDown : faChevronCircleRight} />
                                                    </span>
                                                </div>
                                                <Collapse isOpen={openSections[section.title]}>
                                                    {filteredFields.map((key) => {
                                                    let value = data[key];
                                                    let valType = typeOf(value);
                                                    if (CUSTOM_RENDERERS[key]) {
                                                        return CUSTOM_RENDERERS[key](value);
                                                    }
                                                    return (
                                                        <div key={key} className="abt-deal-field stacked-field">
                                                        <div className="field-label">
                                                            {SHORTHEAD(formatLabel(key))} :
                                                        </div>

                                                        <div className="field-value">
                                                            {valType === "Object"
                                                            ? getTilesStatusDropdown(data, key, "Object")
                                                            : getTilesStatusDropdown(data, key, "String")}
                                                        </div>
                                                        </div>
                                                    );
                                                    })}
                                                </Collapse>
                                                </div>
                                            )})}
                                            {/* {
                                                clientkey?.map((key, e) => {
                                                    let originalKey = key.replaceAll('sandeepext', '');
                                                    originalKey = originalKey.replaceAll('_', ' ');
                                                    originalKey = originalKey.replaceAll('__', ' ');
                                                    let value = data[key];
                                                    let valType = typeOf(value);
                                                    // console.log("line 205" + valType);
                                                    // console.log("line 205" + key);
                                                    // console.log("line 205" + data[key]);
                                                    return (
                                                        <>
                                                            {originalKey.includes("$") ? "" : <><p
                                                                className="abt-deal-field"
                                                            >
                                                                <strong
                                                                    className="custom-label-job-head"
                                                                >{originalKey}:
                                                                </strong>
                                                                {textKey === originalKey && (data[key] != "Yes" &&
                                                                    data[key] != "No") ? <input
                                                                    type="text"
                                                                    defaultValue={data[key]}
                                                                    onChange={(event) => {

                                                                    }}

                                                                />
                                                                    : textKey == originalKey && (data[key] == "Yes" ||
                                                                        data[key] == "No") ?
                                                                        <select
                                                                            className='select-client'
                                                                            name={key}

                                                                            defaultValue={data[key]}
                                                                        >
                                                                            <option>Yes</option>
                                                                            <option>No</option>
                                                                        </select> :
                                                                        <span
                                                                        >
                                                                            {
                                                                                valType == "Object" ? getTilesStatusDropdown(data, key, 'Object') : getTilesStatusDropdown(data, key, 'String')
                                                                            }
                                                                        </span>
                                                                }
                                                            </p>
                                                            </>
                                                            }
                                                        </>
                                                    )
                                                })
                                            } */}
                                        </div>
                                    </Collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div style={{paddingBottom:1}} className="col-3-border outer-border-3">

                        <div className="deal-details-topbox">
                            <p>
                                <strong className="custom-label-client-head">Client:</strong> <span className="padl-14 client-text-style" >{data.Account_Name}</span>
                            </p>
                            <p>
                                <strong className="custom-label-client-head">Client Number:</strong>  <span className="padl-10">{data.Account_Number}</span>
                            </p>
                            <p>
                                <strong className="custom-label-client-head">Start Date:</strong>  <span className="padl-10">{GetFormattedDate()}</span>
                            </p>
                            <p>
                                <strong className="custom-label-client-head">Priority: </strong> <span className="padl-10 star-color" >
                                    <FontAwesomeIcon icon={filledstar} />
                                    <FontAwesomeIcon icon={filledstar} />
                                    <FontAwesomeIcon icon={filledstar} />
                                    <FontAwesomeIcon icon={faStar} />
                                    <FontAwesomeIcon icon={faStar} />
                                </span>
                            </p>
                            <p>
                                <strong className="custom-label-client-head">Client Status: </strong> <span className="padl-14 inprogress-text">Active  <FontAwesomeIcon
                                    className="mar-Inprogess-icon"
                                    icon={faCaretDown}
                                /></span>
                            </p>
                            <p>
                                <strong className="custom-label-client-head">Phone Number:</strong>  <span className="padl-10">{data.Phone}</span>
                            </p>
                        </div>

                        <div className="about-overflow">
                            <div className="deal-details-bottumbox">
                                <div
                                style={{marginLeft:'-12px'}}
                                    className="head-list-style font-14"
                                    onClick={() => {
                                        setAboutToggle(!aboutToggle);
                                    }}
                                >
                                    {aboutToggle ? (
                                        <FontAwesomeIcon
                                            className="mar-right-5"
                                            icon={faCaretDown}
                                        />
                                    ) : (
                                        <FontAwesomeIcon
                                            className="mar-right-5"
                                            icon={faCaretRight}
                                        />
                                    )}
                                    About This Client
                                </div>
                                <Collapse isOpen={aboutToggle}>
                                    {
                                        clientkey.length > 0 ?
                                            clientkey.map((key, e) => {
                                                let originalKey = key.replaceAll('sandeepext', '');
                                                originalKey = originalKey.replaceAll('_', ' ');
                                                originalKey = originalKey.replaceAll('__', ' ');
                                                let value = data[key];
                                                let valType = typeOf(value);
                                                console.log("line 205" + valType);
                                                return (
                                                    <>
                                                        {originalKey.includes("$") ? "" : <><p
                                                            className="abt-deal-field"
                                                        >
                                                            <strong
                                                                className="custom-label-job-head"
                                                            >{originalKey}:
                                                            </strong>
                                                            {textKey === originalKey && (data[key] != "Yes" &&
                                                                data[key] != "No") ? <input
                                                                type="text"
                                                                // type={getTagType(key)}
                                                                defaultValue={data[key]}
                                                                onChange={(event) => {
                                                                    // editValues(event, jobData[key], key);
                                                                }}

                                                            />
                                                                : textKey == originalKey && (data[key] == "Yes" ||
                                                                data[key] == "No") ?
                                                                    <select
                                                                        className='select-client'
                                                                        name={key}
                                                                        // onChange={handleOnChange}
                                                                        defaultValue={data[key]}
                                                                    >
                                                                        <option>Yes</option>
                                                                        <option>No</option>
                                                                    </select> :
                                                                    <span
                                                                    >
                                                                        {
                                                                            valType == "Object" ? data[key].name:data[key]

                                                                        }
                                                                    </span>


                                                            }
                                                            {
                                                                (originalKey === "Owner") || (originalKey == "Deal Name") || (originalKey == "Client") ?
                                                                    <FontAwesomeIcon
                                                                        icon={faLock}
                                                                    />
                                                                    :
                                                                    <FontAwesomeIcon
                                                                        icon={faPen}
                                                                        id={originalKey}
                                                                        onClick={() => {
                                                                            // spanClickHandler(jobData[key], originalKey)
                                                                        }}
                                                                    />

                                                            }

                                                        </p>

                                                        </>
                                                        }



                                                       
                                                    </>
                                                )

                                            })
                                            : <></>
                                    }



                                </Collapse>
                            </div>
                        </div>
                    </div> */}
                </div>
                <div style={getStyleExpandIco()} className={
                    (rightState && leftState) ? "widthper-100 pos-relative" :
                        rightState || leftState ? (rightState ? "pad-l0 widthper-79 pos-relative" : "pad-r0 widthper-79 pos-relative") : "pad-l0 pad-r0 widthper-58 pos-relative"}>
                    {rightState ? <img src={rightexpandactive} className="mid-right-icon-active" onClick={changeRightExpand} /> :
                        <img src={rightexpand} className="mid-right-icon" onClick={changeRightExpand} />}
                    {leftState ?
                        key != "progress" ?

                            <img src={leftexpandactivegray}
                                className="mid-left-icon-active" onClick={changeLeftExpand} />
                            : <img src={leftexpandactive} className="mid-left-icon-active" onClick={changeLeftExpand} /> :
                        key != "progress" ? <img src={blurLeftPng} className="mid-left-icon" onClick={changeLeftExpand} /> :
                            <img src={leftexpand} className="mid-left-icon" onClick={changeLeftExpand} />}



                    <div className="outer-border-6 task-group-tabs">
                        <Tabs

                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="job-parent-tabs"
                        // className={
                        //     (rightState && leftState) ? "job-parent-tabs widthper-100 job-middle-tab job-middle-tabs clientmiddle-tab-padding-doubleActive line-height-36" :
                        //         rightState || leftState ? "job-parent-tabs job-middle-tab job-middle-tabs clientmiddle-tab-padding-active line-height-33" :
                        //             "job-parent-tabs job-middle-tab job-middle-tabs clientmiddle-tab-padding line-height-33"}
                        >
                            {tabArr.map(tab => getViewTabs(tab))}
                            {/* <Tab className="client_body_deals" eventKey="progress" title="Deals & Quotes">
                                <DealList
                                    dealLocation={"Accounts"}
                                    data={data}
                                    params={{ module: 'Deals', action: 'listview' }}
                                    history={history}
                                    location={location} />
                            </Tab>
                            <Tab eventKey="emails" title="Emails">
                                Emails
                            </Tab>
                            <Tab eventKey="notes" title="Notes">
                                Notes
                            </Tab>
                            <Tab className={"client-body-task"} eventKey="tasks" title="Tasks">
                                <TaskListWithDeal data={data} />
                              
                            </Tab>
                            <Tab eventKey="activities" title="Activities">
                                Activities
                            </Tab>
                            <Tab eventKey="accounting" title="Accounting">
                                Accounting
                            </Tab>
                            <Tab eventKey="workdrive" title="Workdrive">
                                <Tab_Workdrive data={data} />
                            </Tab> */}
                        </Tabs>
                        <AntdPopover placement="bottom" trigger={'click'} content={<>


                            {remaingTab.map((tab, index) => {
                                return <div className="row task-filter-hovr"><div onClick={() => {
                                    const tabs = [...tabArr];
                                    const remTab = [...remaingTab];
                                    let remainTab = tabs[tabs.length - 1]
                                    tabs[tabs.length - 1] = tab;
                                    remTab[index] = remainTab;
                                    setRemaingTab(remTab);
                                    setTabArr(tabs);
                                    setKey(tab.toLowerCase());
                                }} className="col-sm-9">
                                    <a>
                                        {tab}
                                    </a>
                                </div></div>
                            })}


                        </>}>
                            <FontAwesomeIcon className="more-tab-body-icon" icon={faEllipsisV} />
                        </AntdPopover>
                    </div>
                </div>

                <div className={rightState ? "display-none" : "widthper-21"}>
                    <div className="col-3-border outer-border-3">
                        <div className="job-rightbox-overflow">

                            <div className="deal-details-right-topbox">

                                <div
                                    className="head-list-style font-14 ml-3 collapse-body-tiles collapse-body-tiles-right-links"
                                    onClick={() => {
                                        setSettingToggle(!settingToggle);
                                    }}
                                >
                                    {settingToggle ? (
                                        <FontAwesomeIcon
                                            className="mar-right-5"
                                            icon={faChevronCircleDown}
                                        />
                                    ) : (
                                        <FontAwesomeIcon
                                            className="mar-right-5"
                                            icon={faChevronCircleRight}
                                        />
                                    )}
                                    Account Setting
                                </div>
                                <p style={{ width: '100%' }} className="collapse-body-tiles-border collapse-body-tiles-right-links"></p>
                                <Collapse isOpen={settingToggle}>
                                    Account Setting
                                </Collapse>



                            </div>
                            <div className="deal-details-right-midbox">
                                <div
                                    className="head-list-style font-14 collapse-body-tiles collapse-body-tiles-right-links"
                                    onClick={() => {
                                        setServiceToggle(!serviceToggle);
                                    }}
                                >
                                    {serviceToggle ? (
                                        <FontAwesomeIcon
                                            className="mar-right-5"
                                            icon={faChevronCircleDown}
                                        />
                                    ) : (
                                        <FontAwesomeIcon
                                            className="mar-right-5"
                                            icon={faChevronCircleRight}
                                        />
                                    )}
                                    Service Setting
                                </div>
                                <div style={{ width: '100%' }} className="collapse-body-tiles-border collapse-body-tiles-right-links"></div>
                                <Collapse isOpen={serviceToggle}>

                                    Service Setting

                                </Collapse>

                            </div>

                            <div className="deal-details-right-midbox pr-2 mt-2">
                                <RolesPopupData
                                    openRoleModal={openRoleModal}
                                    setprojectRoleObject={setprojectRoleObject}
                                    projectRoleObject={projectRoleObject}
                                    onCloseRoleModal={onCloseRoleModal}
                                    Deal_Id={data?.id}
                                    TypeOpDropdown="Accounts"
                                    ClientName={data?.Account_Name} 
                                    allRoles = {allRoles}
                                    setOpenRoleMadal = {()=>{
                                        setOpenRoleMadal({ open: false, module: "", data: null, type: "create" })
                                        fetRoles({ Client_Id: data.id });
                                    }}
                                    />
                                <div
                                    className="head-list-style font-14  align-items-center justify-content-between "
                                    onClick={() => {
                                        setContactToggle(!contactToggle);
                                    }}
                                >
                                    <div className="collapse-body-tiles collapse-body-tiles-right-links">
                                        {contactToggle ? (
                                            <FontAwesomeIcon
                                                className="mar-right-5"
                                                icon={faChevronCircleDown}
                                            />
                                        ) : (
                                            <FontAwesomeIcon
                                                className="mar-right-5"
                                                icon={faChevronCircleRight}
                                            />
                                        )}
                                        Account Roles
                                    </div>
                                    <div style={{ width: '100%' }} className="collapse-body-tiles-border collapse-body-tiles-right-links"></div>

                                </div>

                                <Collapse className="contact-roles" isOpen={contactToggle}>
                                    <div className="deal-details-topbox">
                                        <Button style={{ width: "auto", padding: "7px" }} type='primary'
                                            onClick={() => { setOpenRoleMadal({ open: true, module: "userroles", data: null, type: "create" }); }}
                                        >Add Role</Button>

                                        {selectedContactRole.map((item, index) => {
                                            return (<div key={index} className="role-row"> 
                                                         <div className="role-info">
                                                           <span className="user-text">
                                                             {renderFieldData({...item, flag: "Zoho Users"})}
                                                           </span>
                                                           <span className="role-text">
                                                             {renderFieldData({ ...item, flag: "Role" })}
                                                           </span> 
                                                         </div>

                                                         <div className="role-actions">
                                                           <GrEdit
                                                             onClick={(e) => {
                                                              setOpenRoleMadal({ open: true, module: "userroles", data: item?.UserType, type: "edit" });
                                                              setprojectRoleObject({ ...item, RoleId: "Roles_" + item.RoleId });
                                                             }}
                                                           />
                                                           <RiDeleteBinLine color="red" onClick={(e) => {
                                                                handleDeleteUserRole(item);
                                                             }} />
                                                         </div>  
                                                </div>
                                            );
                                        })}

                                        <p></p>
                                    </div>

                                </Collapse>

                            </div>


                            <div className="deal-details-bottumbox p-0 mt-2">
                                <div
                                    className="head-list-style font-14 collapse-body-tiles collapse-body-tiles-right-links"
                                    onClick={() => {
                                        setDocumentToggle(!documentToggle);
                                    }}
                                >
                                    {documentToggle ? (
                                        <FontAwesomeIcon
                                            className="mar-right-5"
                                            icon={faChevronCircleDown}
                                        />
                                    ) : (
                                        <FontAwesomeIcon
                                            className="mar-right-5"
                                            icon={faChevronCircleRight}
                                        />
                                    )}
                                    Documents
                                </div>
                                <div style={{ width: '100%' }} className="collapse-body-tiles-border collapse-body-tiles-right-links"></div>
                                <Collapse isOpen={documentToggle}>

                                    <p>
                                        <span>Document</span>
                                    </p>
                                </Collapse>

                            </div>

                            <div className="deal-details-bottumbox p-0 mt-2">
                                <div
                                    className="head-list-style font-14 collapse-body-tiles collapse-body-tiles-right-links"
                                    onClick={() => {
                                        setAccountingToggle(!accountingToggle);
                                    }}
                                >
                                    {accountingToggle ? (
                                        <FontAwesomeIcon
                                            className="mar-right-5"
                                            icon={faChevronCircleDown}
                                        />
                                    ) : (
                                        <FontAwesomeIcon
                                            className="mar-right-5"
                                            icon={faChevronCircleRight}
                                        />
                                    )}
                                    Accounting Status
                                </div>
                                <div style={{ width: '100%' }} className="collapse-body-tiles-border collapse-body-tiles-right-links"></div>
                                <Collapse isOpen={accountingToggle}>

                                    <p>
                                        <span>Account Status Completed</span>
                                    </p>
                                </Collapse>

                            </div>
                        </div>
                    </div>
                </div>
            </Row>
        </div>
    );
};
export default ClientBody;
